import { useContext } from 'react';
import { AuthContext } from 'components/lib';

export function useCan(permission) {
	const { permission: permissions } = useContext(AuthContext);
	return !!permissions?.[permission];
}
